import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "referenceRelationshipLabel",
})
export class ReferenceRelationshipLabelPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const relationship = (value || "").trim().toLowerCase();
    if (!relationship) {
      return "";
    }

    const labels: Record<string, string> = {
      father: "Padre",
      mother: "Madre",
      sibling: "Hermano(a)",
      son: "Hijo",
      daughter: "Hija",
      spouse: "Esposo(a)",
      friend: "Amigo(a)",
      workmate: "Compañero(a) de trabajo",
      neighbour: "Vecino(a)",
      employee: "Empleado(a)",
      other: "Otro",
    };

    return labels[relationship] || value;
  }
}
